import { Button, ButtonProps, Stack, StackProps, useMediaQuery } from '@mui/material';
import { FunctionComponent, ReactElement } from 'react';

/**
 * Useful for preventing components becoming too wide for a low width screen. 
 * WCAG 1.4.10 requires UI be visible at 320px without wrapping.
 */
export function useScreenIsNarrow(): boolean {
	return useMediaQuery(theme => theme.breakpoints.down('sm'));
}

export const AccessibleButton: FunctionComponent<ButtonProps> = (props) => {
	const narrow = useScreenIsNarrow();

	return <Button {...props} size={(narrow && (props.size === 'large')) ? 'medium' : props.size} />;
};

export const AccessibleStack: FunctionComponent<StackProps> = (props) => {
	const narrow = useScreenIsNarrow();
	return <Stack {...props} direction={narrow ? 'column' : props.direction} />;
};

type FilterControlsLayoutProps = {
	Controls: ReactElement;
	Buttons: ReactElement;
};

export const FilterControlsLayout: FunctionComponent<FilterControlsLayoutProps> = (props) => {
	return <AccessibleStack direction='row'
		sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
		{props.Controls}

		<AccessibleStack direction='row' spacing={1}>
			{props.Buttons}
		</AccessibleStack>
	</AccessibleStack>;
};